<template>
    <div id="app">
        <Navigation/>
        <div class="pt-50px">
            <router-view/>
        </div>
        <portal-target name="modal"></portal-target>
    </div>
</template>

<script>
import Navigation from './components/Navigation.vue'

export default {
    components:{
        Navigation,
    },
}
</script>